import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import ChartPieMarket from '../charts/ChartPieMarket';
import ChartRadarCompetitor from '../charts/ChartRadarCompetitor';
import { SWOT_DATA } from '../data/mockData';
import { Rocket, Target, Shield } from 'lucide-react';

// 区块5：市场与竞争
export default function Section05Market() {
  return (
    <SectionWrapper
      id="market"
      title="市场与竞争"
      subtitle="本项目以数学师范垂直细分领域为切口，依托华中师范大学学科优势，构建难以复制的竞争壁垒。"
    >
      {/* 顶部：市场规模饼图 */}
      <ScrollReveal>
        <div className="glass-card mb-8 min-h-[420px]">
          <ChartPieMarket />
        </div>
      </ScrollReveal>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 中部左侧：SWOT 分析 */}
        <ScrollReveal>
          <div className="grid grid-cols-2 gap-4 h-full">
            {Object.entries(SWOT_DATA).map(([key, item], index) => {
              const colors = {
                S: 'border-l-4 border-l-cyan bg-cyan/5',
                W: 'border-l-4 border-l-orange bg-orange/5',
                O: 'border-l-4 border-l-green bg-green/5',
                T: 'border-l-4 border-l-red-500 bg-red-500/5',
              };
              return (
                <div key={key} className={`glass-card ${colors[key]}`}>
                  <h4 className="text-xl font-bold text-white mb-3">{item.title}</h4>
                  <ul className="space-y-2">
                    {item.items.map((text, idx) => (
                      <li key={idx} className="text-base text-slate-300 flex items-start gap-2">
                        <span className="text-gold">•</span>
                        {text}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </ScrollReveal>

        {/* 中部右侧：竞品对比雷达图 */}
        <ScrollReveal delay={150}>
          <div className="glass-card min-h-[480px]">
            <ChartRadarCompetitor />
          </div>
        </ScrollReveal>
      </div>

      {/* 底部：3阶段市场进入时间轴 */}
      <ScrollReveal delay={200}>
        <div className="glass-card mt-8">
          <h3 className="text-2xl font-bold text-gold mb-6 text-center">三阶段市场进入策略</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: Rocket, title: 'MVP验证', desc: '聚焦华中师范大学，打磨五维模型与产品体验' },
              { icon: Target, title: '院校推广', desc: '复制至5所部属师范院校，建立师范生用户基础' },
              { icon: Shield, title: '县域扩张', desc: '以双师课堂切入县域中学，形成B端G端收入' },
            ].map((stage, index) => {
              const Icon = stage.icon;
              return (
                <div key={index} className="text-center p-4 rounded-xl bg-white/5">
                  <Icon className="w-12 h-12 text-cyan mx-auto mb-4" />
                  <h4 className="text-xl font-bold text-white mb-2">{stage.title}</h4>
                  <p className="text-base text-slate-300">{stage.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </ScrollReveal>
    </SectionWrapper>
  );
}
